"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lowerFirst = void 0;
exports.lowerFirst = (value) => value[0].toLowerCase() + value.slice(1);
//# sourceMappingURL=lower-first.js.map